import { render, staticRenderFns } from "./ToolPanelLabel.vue?vue&type=template&id=6811ce8c&scoped=true"
import script from "./ToolPanelLabel.vue?vue&type=script&setup=true&lang=ts"
export * from "./ToolPanelLabel.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ToolPanelLabel.vue?vue&type=style&index=0&id=6811ce8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6811ce8c",
  null
  
)

export default component.exports